export const DEFAULT_AVATAR_SIZE_REM = 1.25;
